import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { UpsellLeadsActions } from ".";
import {
  CLEAR_UPSELL_LEADS_STATE,
  CLEAR_UPSELL_INSIGHT_STATE,
  CLEAR_RECOMMENDED_TEMPLATE_STATE,
  FETCH_UPSELL_LEADS_LIST_PROGRESS,
  FETCH_UPSELL_LEADS_LIST_SUCCESS,
  FETCH_UPSELL_LEADS_LIST_FAILED,
  FETCH_UPSELL_INSIGHT_PROGRESS,
  FETCH_UPSELL_INSIGHT_SUCCESS,
  FETCH_UPSELL_INSIGHT_FAILED,
  FETCH_RECOMMENDED_TEMPLATE_PROGRESS,
  FETCH_RECOMMENDED_TEMPLATE_SUCCESS,
  FETCH_RECOMMENDED_TEMPLATE_FAILED,
  AUTO_GENERATE_CAMPAIGN_PROGRESS,
  AUTO_GENERATE_CAMPAIGN_SUCCESS,
  AUTO_GENERATE_CAMPAIGN_FAILED,
} from "./upsellLeadsActions";
import { initialUpsellLeadsState } from "./defaultState";
import { IUpsellLeadsState } from "./upsellLeads.types";

export const upsellLeadsReducer = (
  state: IStoreState["upsellLeads"] = initialUpsellLeadsState,
  action: UpsellLeadsActions
) => {
  switch (action.type) {
    // ============== UPSELL LEADS LIST ACTIONS ==============
    case FETCH_UPSELL_LEADS_LIST_PROGRESS: {
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_UPSELL_LEADS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_UPSELL_LEADS_LIST_FAILED: {
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.list.loading = LoadState.Failed;
      });
      return newState;
    }
    case CLEAR_UPSELL_LEADS_STATE: {
      return initialUpsellLeadsState;
    }

    // ============== UPSELL INSIGHT ACTIONS ==============
    case FETCH_UPSELL_INSIGHT_PROGRESS: {
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.insight.loading = LoadState.InProgress;
        draftState.insight.error = null;
      });
      return newState;
    }
    case FETCH_UPSELL_INSIGHT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.insight.loading = LoadState.Loaded;
        draftState.insight.data = data;
        draftState.insight.error = null;
      });
      return newState;
    }
    case FETCH_UPSELL_INSIGHT_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.insight.loading = LoadState.Failed;
        draftState.insight.error = error || "Failed to fetch upsell insights";
      });
      return newState;
    }
    case CLEAR_UPSELL_INSIGHT_STATE: {
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.insight = initialUpsellLeadsState.insight;
      });
      return newState;
    }

    // ============== RECOMMENDED TEMPLATE ACTIONS ==============
    case FETCH_RECOMMENDED_TEMPLATE_PROGRESS: {
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.recommendedTemplate.loading = LoadState.InProgress;
        draftState.recommendedTemplate.error = null;
      });
      return newState;
    }
    case FETCH_RECOMMENDED_TEMPLATE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.recommendedTemplate.loading = LoadState.Loaded;
        draftState.recommendedTemplate.data = data;
        draftState.recommendedTemplate.error = null;
      });
      return newState;
    }
    case FETCH_RECOMMENDED_TEMPLATE_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.recommendedTemplate.loading = LoadState.Failed;
        draftState.recommendedTemplate.error =
          error || "Failed to fetch recommended templates";
      });
      return newState;
    }
    case CLEAR_RECOMMENDED_TEMPLATE_STATE: {
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.recommendedTemplate = initialUpsellLeadsState.recommendedTemplate;
      });
      return newState;
    }

    // ============== AUTO GENERATE CAMPAIGN ACTIONS ==============
    case AUTO_GENERATE_CAMPAIGN_PROGRESS: {
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.campaign.loading = LoadState.InProgress;
        draftState.campaign.error = null;
      });
      return newState;
    }
    case AUTO_GENERATE_CAMPAIGN_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.campaign.loading = LoadState.Loaded;
        draftState.campaign.lastGeneratedCampaignUuid = data.market_campaign_uuid;
        draftState.campaign.error = null;
      });
      return newState;
    }
    case AUTO_GENERATE_CAMPAIGN_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState: IUpsellLeadsState) => {
        draftState.campaign.loading = LoadState.Failed;
        draftState.campaign.error = error || "Failed to generate campaign";
      });
      return newState;
    }

    default:
      return state;
  }
};
